module.exports = __webpack_public_path__ + "static/img/product_banner_29_zh.a4a2d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_29_zh.png
// module id = Eh10
// module chunks = 34